<app-popup-header></app-popup-header>
<div>
  <div style="text-align: center;" *ngIf="isShowQuantity">
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" [checked]="isByAmount" (click)="onChecked(3)">
      <span>&nbsp;{{localService.languageContent.paging.by_amount}}</span>
    </label>
    &nbsp;
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" [checked]="isByQuantity" (click)="onChecked(2)">
      <span>&nbsp;{{localService.languageContent.paging.by_qty}}</span>
    </label>
    &nbsp;
    <label style="margin-left:15px;font-weight:normal;" *ngIf="isShowProfit">
      <input type="radio" name="settings" [checked]="isByProfit" (click)="onChecked(1)">
      <span>&nbsp;{{localService.languageContent.paging.by_profit}}</span>
    </label>
  </div>
  <div style="text-align: center;" *ngIf="!isShowQuantity && isShowProfit">
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" [checked]="isByAmount" (click)="onChecked(3)">
      <span>&nbsp;{{localService.languageContent.paging.by_amount}}</span>
    </label>
    &nbsp;
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" [checked]="isByProfit" (click)="onChecked(1)">
      <span>&nbsp;{{localService.languageContent.paging.by_profit}}</span>
    </label>
  </div>
  <div style="display: block;">
    <canvas *ngIf="lineChartData.labels.length > 0 && isShow" baseChart width="width" height="height" [type]="'bar'"
      [data]="lineChartData" [options]="lineChartOptions" [legend]="lineChartLegend">
    </canvas>
  </div>
</div>